import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Cleave from 'cleave.js/dist/cleave-react';
import moment from 'moment';
import {
    HelpBlock,
    FormGroup,
    FormControl,
    ControlLabel,
    Tooltip,
    OverlayTrigger
} from 'react-bootstrap';
import isDefined from '../utils/isDefined';
import isEmptyString from '../utils/isEmptyString';
import AdditionalInfoComponentC from './AdditionalInfoComponent';
import 'cleave.js/dist/addons/cleave-phone.us'

import TooltipContainer from './Tooltip';
import { isEmpty } from 'lodash';
import { EMAIL_REGEX } from '../../../../constants';

export class InputContainer extends React.PureComponent {
    constructor(props) {
        super(props);
        const name = this.props.data.name;
        const initialValue = this.props.initialValues[name];
        const value = isDefined(initialValue) ? initialValue : '';

        this.state = {
            value: value,
            disabled:
                this.props.initialParams[name] && this.props.initialParams[name].disabled
                    ? this.props.initialParams[name].disabled
                    : false,
            isValid: null,
            validationMessage: '',
            showValidationMessage: false,
            unSupportedCharacters: '',
            initialRoleRelationUpdated: false,
            currencyValue: this.props.data.inputFormat === 'currency' ? value : null,
            showWarningMessage: false,
            warningMessage: '',
            WarningCost: false,
        };

        if (isDefined(initialValue) && this.props.data.inputFormat === 'date') {
            this.state.value = moment(this.state.value)
                .format('MM/DD/YYYY')
        }

        this.handleChange = this.handleChange.bind(this);
        this.getValidationState = this.getValidationState.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.hideErrorMessage = this.hideErrorMessage.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props !== nextProps && !isEmpty(nextProps.addressValues)) {
            const name = nextProps.data.name;
            const initialValue = nextProps.addressValues[name];
            if (initialValue || initialValue === '') {
                this.setState({
                    value: isDefined(initialValue) ? initialValue : ''
                })
            }
        }

        const dataName = nextProps.data.name;
        if (this.props.hidden !== nextProps.hidden && nextProps.hidden === true && this.state.value !== null) {
            this.setState({
                value: ''
            })
        }
        if (this.props.hidden !== nextProps.hidden && nextProps.hidden === true && this.state.currencyValue !== null) {
            this.setState({
                currencyValue: null
            });
        }
        if (this.state.initialRoleRelationUpdated && !nextProps.hidden && !this.state.value) {
            this.setState({
                value: this.props.initialValues[dataName],
                initialRoleRelationUpdated: false,
            })
        }
    }

    componentWillMount() {
        this.setState({
            initialRoleRelationUpdated: this.props.initialValues[this.props.data.name] && (this.props.data.name.endsWith('RoleOther') || this.props.data.name.endsWith('RelationshipOther'))
        })
        if (!!this.props.data.attributes && !!this.props.data.attributes.options) {
        const option = this.props.data.attributes.options[0];
            if (this.props.initialValues[this.props.data.name]) {
                this.props.handleSupplementTrigger(option.supplementalquestionIds);
            } else {
                this.props.handleSupplementTrigger([]);
            }
        }
        const referralCarriers = ['argo', 'colony', 'peleus']
        const checkCarrier = (val) => !/^\s+$/.test(this.props.initialValues.generalLiabilityCarrier) && this.props.initialValues.generalLiabilityCarrier.toLowerCase().match(/[^\s]+/)[0] === val;
        if (this.props.data.disableOtherField && this.props.initialValues.generalLiabilityCarrier) {
            if (!referralCarriers.some(checkCarrier)) {
                this.props.handleDisableFieldChange(this.props.initialValues.generalLiabilityCarrier, this.props.data.name, '');
            } else {
                this.props.handleDisableFieldChange(this.props.initialValues.generalLiabilityCarrier, this.props.data.name, this.props.data.disableOtherField);
            }
        }
    }

    getValidationState() {
        // this bit of code acts as a circuit breaker
        // We want get validation to trigger
        // a validation function and when results are back we need to call it again
        // But this breaks the loops
        if (this.state.isValid) {
            const isValid = this.state.isValid;
            this.state.isValid = null;
            return isValid;
        }

        // only trigger validation if the value changes
        if (
            this.state.value !== '' &&
            this.props.data.attributes &&
            this.props.data.attributes.validationFunc &&
            this.props.validation[this.props.data.attributes.validationFunc]
        ) {
            this.props.validation[this.props.data.attributes.validationFunc](
                this.props.data.name,
                this.state.value
            ).then(result => {
                this.setState({
                    isValid: result.status ? 'success' : 'error',
                    validationMessage: result.status ? '' : result.message
                });
            });
        }

        if (this.state.isValid !== null) {
            return this.state.isValid;
        }

        return;
    }

    handleBlur(event) {
        let value;

        switch (this.props.data.inputFormat) {
            case 'currency':
                break;
            case 'number':
                value = event.target.rawValue;
                break;
            default:
                value = event.target.value;
        }

        let formattedValue;
        const regex = new RegExp(/([^\x07-\x15\x20-\x7E])/g);
        const regexEmail = new RegExp(EMAIL_REGEX);

        if (value && regex.test(value)) {
            const unSupportedCharactersArray = value.match(regex);
            const unSupportedCharacters = unSupportedCharactersArray.join(",");
            formattedValue = value.replace(regex, "");
            this.setState({ showValidationMessage: true, value: formattedValue, unSupportedCharacters });
            setTimeout(this.hideErrorMessage, 3000);
        } else {
            this.setState({ showValidationMessage: false });
        }

        if (this.props.data.name === 'auditorEmail') {
            let invalidEmail = false;
            if (formattedValue === undefined) {
                if (typeof event.target.value === 'string' && event.target.value.length > 0 && !regexEmail.test(event.target.value.trim())) {
                    invalidEmail = true;
                }
            } else {
                if (typeof formattedValue === 'string' && formattedValue.length > 0 && !regexEmail.test(formattedValue.trim())) {
                    invalidEmail = true;
                }
            }

            if (invalidEmail) {
                this.setState({
                    showWarningMessage: true,
                    warningMessage: 'Invalid Email.'
                });
            } else {
                this.setState({
                    showWarningMessage: false,
                    warningMessage: ''
                });
            }
        }
    }

    hideErrorMessage() {
        this.setState({ showValidationMessage: false });
    }

    handleChange(event) {
        let value;
        let currencyValue = null;
        const regex= new RegExp(/^\d*[.]?\d*$/);
        const regexWeb = new RegExp(/\s/g);
        const referralCarriers = ['argo', 'colony', 'peleus']
        const checkCarrier = fieldValue => carrier => !/^\s+$/.test(fieldValue) && fieldValue.toLowerCase().trim().match(/[^\s]+/)[0] === carrier;
        if (this.props.data.name==='totalCost') {
            const value=event.target.value.replace(/\$|,/gi, "")
            if (value>=1000000000000) {
                this.setState({ WarningCost: true});
            }
            else {
                this.setState({ WarningCost: false});
            }
        }
        if (this.props.data.disableOtherField) {
            /**
             * If a field has disableOtherField then check for specific field name logic. Add a separate
             * condition for additional fields that use the disableOtherField in the future.
             */
            if (this.props.data.name === 'generalLiabilityCarrier') {
                if (typeof event.target.value === 'string'
                && event.target.value.length > 0
                && referralCarriers.some(checkCarrier(event.target.value))) {
                    this.props.handleDisableFieldChange(event.target.value, this.props.data.name, this.props.data.disableOtherField);
                } else {
                    this.props.handleDisableFieldChange(event.target.value, this.props.data.name, '');
                }
            }
        }
        if (this.props.data.name==='generalContractorName' || this.props.data.name==='primaryInsuredAddress' || this.props.data.name==='projectAddress') {
            if (event.target.value.length>=36) {
                return;
            }
        }
        if (this.props.data.name==='primaryInsuredCity' || this.props.data.name==='projectCity') {
            if (event.target.value.length>=29) {
                return;
            }
        }
        if (this.props.data.name==='primaryInsuredZipcode' || this.props.data.name==='projectZipcode') {
            if (!event.target.value.match(regex)|| event.target.value.length>=6) {
                return;
            }
        }
        if (this.props.data.name==='primaryInsuredWebsite') {
            if (event.target.value.match(regexWeb)) {
                return;
            }
        }
        if (this.props.data.name==='totalCost'|| this.props.data.name==='generalContractorAmount' || this.props.data.name==='demolitionDetailsCost') {
                    document.getElementById(event.target.id).maxLength=20;
        }
        if (this.props.data.name==='projectScope') {
            if (event.target.value.length>=3001) {
                return;
            }
        }
        if (this.props.data.name==='residentials') {
            if (event.target.value.length>=101) {
                return;
            }
        }
        if (this.props.data.name==='specificFloorsDetails' || this.props.data.name==='demolitionDetailsPrecautions' || this.props.data.name==='workCompleteDescription') {
            if (event.target.value.length>=251) {
                return;
            }
        }
        if (this.props.data.name==='workRemainDescription') {
            if (event.target.value.length>=66) {
                return;
            }
        }
        if (this.props.data.name==='demolitionDetailsMonths') {
            if (event.target.value.length>=3) {
                return;
            }
        }
        if (this.props.data.name==='priorGcResponsible' || this.props.data.name==='generalContractorName' || this.props.data.name==='generalLiabilityCarrier') {
            if (event.target.value.length>=61) {
                return;
            }
        }
        if (this.props.data.name==='sidewalkDetails') {
            if (event.target.value.length>=1001) {
                return;
            }
        }
        if (this.props.data.name==='secondaryNameInsuredName' || this.props.data.name==='secondSecondaryNameInsuredName' || this.props.data.name==='thirdSecondaryNameInsuredName') {
            if (event.target.value.length>=61) {
                return;
            }
        }
        if (this.props.data.name==='secondaryNameInsuredRelationship' || this.props.data.name==='secondSecondaryNameInsuredRelationship' || this.props.data.name==='thirdSecondaryNameInsuredRelationship') {
            if (event.target.value.length>=29) {
                return;
            }
        }

        switch (this.props.data.inputFormat) {
            case 'currency':
                currencyValue = event.target.rawValue;
                break;
            case 'number':
                value = event.target.rawValue;
                break;
            default:
                value = event.target.value;
        }
        if (!!this.props.data.attributes && !!this.props.data.attributes.options) {
            const option = this.props.data.attributes.options[0];
            if (!!event.target.value && option.supplementalquestionIds && option.supplementalquestionIds.length > 0) {
                this.props.handleSupplementTrigger(option.supplementalquestionIds);
            } else {
                this.props.handleSupplementTrigger([]);
            }
        }
        this.setState({
            value,
            currencyValue,
            initialRoleRelationUpdated: false,
        });
        this.props.handleFormChange();
        if (this.props.addressValues) {
            const updatedValue = {};
            updatedValue[this.props.data.name] = value;
            const addressValues = Object.assign({}, this.props.addressValues, updatedValue);
            this.props.handleAddressChange(addressValues);
        }
    }

    handleDateChange(event) {
        this.props.handleFormChange();
        this.setState({ value: event.target.value });
    }

    render() {
        const inputFormat = this.props.data.inputFormat;
        const arr=["TBD", "N/A"];
        let isRequired = false;
        if (this.props.data.inputFormat === 'currency') {
            isRequired = !this.state.currencyValue && this.props.requiredLabel;
        } else {
            isRequired = !this.state.value && this.props.requiredLabel;
        }

        let input;
        const classNamesInput = classNames({
            'mandatoryField': this.props.data.required,
            'placeholder-tooltip-hidden': this.props.data.placeholderHidden,
            'placeholder-tooltip-exposed': this.props.data.placeholderExposed && !this.props.data.placeholderHidden,
            'placeholder': !this.props.data.placeholderHidden && !this.props.data.placeholderExposed,
            'requiredLabel': isRequired
        });

        if (['currency', 'number'].indexOf(this.props.data.inputFormat) > -1) {
            const dollarPrefix = this.props.data.inputFormat === 'currency' ? '$' : '';
            let optionalText = this.props.data.inputFormat=== 'number' ? 'Optional' : '';
            optionalText = this.props.data.required ? '' : optionalText;
            input = (
                <div>
                    {this.props.data.placeholder && (
                        <label className={classNamesInput}>{this.props.data.placeholder}</label>
                    )}
                    <Cleave
                        id={this.props.data.name}
                        className={classNames(
                            'form-control',
                            'number-control',
                            'input-numeral',
                            { filled: this.state.value },
                            { disabled: this.state.disabled }
                        )}
                        autoComplete={true}
                        value={this.state.value}
                        options={{
                            numeral: true,
                            numeralThousandsGroupStyle: 'thousand',
                            prefix: dollarPrefix,
                            rawValueTrimPrefix: true
                        }}
                        placeholder={optionalText}
                        onChange={this.handleChange}
                    />
                </div>
            );
        }
        else if (['phone'].indexOf(this.props.data.inputFormat) > -1) {
            let optionalText = this.props.data.inputFormat=== 'phone' ? 'Optional' : '';
            optionalText = this.props.data.required ? '' : optionalText;
            input = (
                <div>
                    {this.props.data.placeholder && (
                        <label className={classNamesInput}>{this.props.data.placeholder}</label>
                    )}
                    <Cleave
                        id={this.props.data.name}
                        className={classNames(
                            'phone',
                            'form-control',
                            'number-control',
                            'input-numeral',
                            { filled: this.state.value },
                            { disabled: this.state.disabled }
                        )}
                        autoComplete={true}
                        value={this.state.value}
                        options={{
                            delimiter: '-',
                            phone: true,
                            phoneRegionCode: 'us'
                        }}
                        placeholder={optionalText}
                        onChange={this.handleChange}
                    />
                </div>
            ); }
         else if (['date'].indexOf(this.props.data.inputFormat) > -1) {
            input = (
                <div>
                    {this.props.data.placeholder && (
                        <label className={classNamesInput}>{this.props.data.placeholder}</label>
                    )}
                    <Cleave
                        id={this.props.data.name}
                        className={classNames(
                            'form-control',
                            'number-control',
                            'input-numeral',
                            { filled: this.state.value },
                            { disabled: this.state.disabled }
                        )}
                        autoComplete={true}
                        value={this.state.value}
                        placeholder="mm/dd/yyyy"
                        options={{
                            date: true,
                            datePattern: ['m', 'd', 'Y']
                        }}
                        onChange={this.handleDateChange}
                    />
                </div>
            );
        } else {
            let plcHolder = this.props.data.required ? '' : 'Optional';
            plcHolder = this.props.data.placeholderOnly ? this.props.data.placeholder : plcHolder;
            input = (
                <div>
                     {this.props.data.placeholder && this.props.data.placeholderOnly === undefined && (
                        <label className={classNamesInput}>{this.props.data.placeholder}</label>
                    )}
                    <FormControl
                        className={classNames(
                            { filled: this.state.value },
                            { disabled: this.state.disabled }
                        )}
                        disabled={this.state.disabled ||(this.props.isSameAddress && this.props.addressValues && (this.props.data.questionId== "3b" || this.props.data.questionId == "3d"))}
                        autoComplete={true}
                        id={this.props.data.name}
                        type={inputFormat}
                        onChange={this.handleChange}
                        componentClass={
                            this.props.data.inputType === 'freeform' ? 'textarea' : 'input'
                        }
                        value={this.state.value}
                        placeholder={plcHolder}
                        onBlur={this.handleBlur}
                    />
                    {this.state.showWarningMessage && <span style={{ color: "red" }}>{this.state.warningMessage}</span>}
                    {this.state.showWarningMessage && this.state.showValidationMessage && <br />}
                    {this.state.showValidationMessage && <span style={{ color: "red" }}>Entered input invalid character ({this.state.unSupportedCharacters}) is removed.</span>}
                </div>
            );
        }

        const helpBlock =
            this.state.isValid === 'error' ? (
                <HelpBlock>{this.state.validationMessage}</HelpBlock>
            ) : null;
        return (
            <FormGroup validationState={this.getValidationState()} controlId={this.props.data.name}>
                <div className="label-container">
                    {this.props.data.text && <ControlLabel className={classNames({ mandatoryField: this.props.data.required, requiredLabel: isRequired })}>{this.props.data.text}</ControlLabel>}
                    <TooltipContainer data={this.props.data} />
                </div>
                {input}
                {!this.props.data.helper_uw && this.props.data.helper && <div className={classNames("helper", { highlightHelper: this.props.data.name === 'anticipatedStartDate' ? true : '' })}>{this.props.data.helper}</div>}
                {this.props.data.helper_uw && <div className={classNames("helper", { highlightHelper: this.props.data.name === 'anticipatedStartDate' ? true : '' })}>{this.props.isUnderwriter ? this.props.data.helper_uw : this.props.data.helper}</div>}
                {this.props.data.subHelper && <div className="helper"><span style={{fontWeight: "bold"}}>{this.props.data.subHelperTitle ? this.props.data.subHelperTitle : ""}</span>{this.props.data.subHelper}</div>}
                {helpBlock}
                {this.state.WarningCost && <span style={{ color: "red", lineHeight: "19px"}}>Exposure exceeds the allowable amount for quoting. Please contact your Underwriter for assistance.</span>}
                <AdditionalInfoComponentC
                    additionalInfo1Color={this.props.data.additionalInfo1Color}
                    additionalInfo1={this.props.data.additionalInfo1}
                    additionalInfo2={this.props.data.additionalInfo2}
                    additionalInfoIcon={this.props.data.additionalInfoIcon}
                />
                {arr.includes(this.state.value && this.state.value.toUpperCase().replace(/\s/g, '')) && <div style={{ fontSize: '12px', color: 'red', lineHeight: 2.0}}>{`Please provide valid details. Texts like 'TBD', 'N/A' is not acceptable.`}</div>}
            </FormGroup>
        );
    }
}

InputContainer.propTypes = {
    data: PropTypes.object.isRequired,
    handleFormChange: PropTypes.func.isRequired,
    validation: PropTypes.object.isRequired,
    initialValues: PropTypes.object.isRequired,
    initialParams: PropTypes.object.isRequired
};

export default InputContainer;
